<template>
  <div class="section grid-view">
    <div class="main-content">
      <div class="operations" style="margin-bottom: 5px">
        <div class="triggers">
          <div>
            <el-button
              no="new"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(true)"
            >{{ $t('common.btn.new') }}</el-button>
            <el-button
              no="edit"
              :disabled="!isEdit"
              type="primary"
              @click="showEditDialog(false)"
            >{{ $t('common.btn.edit') }}</el-button>
            <el-button :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
    </div>

    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="'分类1'">
            <el-select v-model="editDialog.form.category1" no="category1" style="width: 100%" placeholder="请选择分类1" clearable>
              <el-option v-for="option in category1Options" :key="option.value" :label="option.label" :value="option.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="'分类2'">
            <el-select v-model="editDialog.form.category2" no="category2" style="width: 100%" placeholder="请选择分类2" clearable>
              <el-option v-for="option in category2Options" :key="option.value" :label="option.label" :value="option.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="'对应港口'">
            <el-select v-model="editDialog.form.port" no="port" style="width: 100%" placeholder="请选择对应港口" filterable clearable>
              <el-option v-for="option in portOptions" :key="option.value" :label="option.label" :value="option.value" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { listBranchFleetByType } from '@/api/basicData/branchFleet'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'TruckClassificationForm',
  components: { cargoAdvanceSelect },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDataChanged: event => {
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        onSelectionChanged: event => {
          const selectedRows = event.api.getSelectedRows()
          if (selectedRows.length > 0) {
            // 找到选中行的节点
            const nodes = event.api.rowModel.rowsToDisplay
            for (let i = 0; i < nodes.length; i++) {
              if (nodes[i].data === selectedRows[0]) {
                this.selectedNode = nodes[i]
                break
              }
            }
          } else {
            this.selectedNode = null
          }
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          checkboxSelection: true,
          width: 100,
          headerCheckboxSelection: true,
          pinned: 'left',
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false

        }, {
          headerName: '分类1',
          field: 'category1',
          width: 300,
          cellRenderer: function(params) {
            if (!params.value) return ''
            const component = params.context.componentParent
            const option = component.category1Options.find(opt => opt.value === params.value)
            return option ? option.label : params.value
          }
        }, {
          headerName: '分类2',
          field: 'category2',
          width: 300,
          cellRenderer: function(params) {
            if (!params.value) return ''
            const component = params.context.componentParent
            const option = component.category2Options.find(opt => opt.value === params.value)
            return option ? option.label : params.value
          }
        }, {
          headerName: '对应港口',
          field: 'port',
          width: 300,
          cellRenderer: function(params) {
            if (!params.value) return ''
            const component = params.context.componentParent
            const option = component.portOptions.find(opt => opt.value === params.value)
            return option ? option.label.split(' - ')[1] : params.value
          }
        }
      ],
      rowData: [],
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          category1: '',
          category2: '',
          port: '',
          companyUuid: ''
        }
      },
      category1Options: [],
      category2Options: [],
      portOptions: [],
      deleteTruckClassificationKeys: [],
      autoIncrementNum: new AutoIncrementNum(),
      selectedNode: null,
      company: {}
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (isRefresh) {
        this.company = row
        this.deleteTruckClassificationKeys = []
        // 先加载分类选项，然后再设置rowData
        this.loadCategoryOptions(() => {
          // 处理从后端加载的车队分类信息，转换为前端期望的结构
          if (row.truckClassificationList && row.truckClassificationList.length > 0) {
            this.rowData = row.truckClassificationList.map(item => {
              return {
                uuid: item.uuid,
                companyUuid: item.companyUuid,
                category1: item.fleetCodeOne || '',
                category2: item.fleetCodeTwo || '',
                port: item.portCode,
                seq: this.autoIncrementNum.getNextNum()
              }
            })
          } else {
            this.rowData = []
          }
        })
      }
    },
    loadCategoryOptions(callback) {
      // 加载分类1数据
      const loading = getLoading()
      Promise.all([
        listBranchFleetByType({ fleetType: '1' }),
        listBranchFleetByType({ fleetType: '2' }),
        this.loadPortOptions()
      ]).then(([res1, res2]) => {
        this.category1Options = res1.data.map(item => ({
          label: item.fleetName,
          value: item.fleetCode
        }))
        this.category2Options = res2.data.map(item => ({
          label: item.fleetName,
          value: item.fleetCode
        }))
        if (callback) callback()
      }).finally(() => loading.close())
    },
    loadPortOptions() {
      return new Promise((resolve, reject) => {
        import('@/api/basicData/seaPort').then(({ getPortList }) => {
          getPortList().then(res => {
            console.log('Port list response:', res)
            this.portOptions = res.data.list.map(item => ({
              label: item.code + ' - ' + item.englishName,
              value: item.code
            }))
            resolve()
          }).catch(reject)
        })
      })
    },

    getSubmitData() {
      const branchFleetInfoList = this.rowData.map(item => {
        // 从分类1获取车队信息
        const fleetCodeOne = item.category1 || ''
        const fleetTypeOne = item.category1 ? '1' : ''
        const fleetNameOne = item.category1
          ? this.category1Options.find(opt => opt.value === item.category1)?.label : ''

        // 从分类2获取车队信息
        const fleetCodeTwo = item.category2 || ''
        const fleetTypeTwo = item.category2 ? '2' : ''
        const fleetNameTwo = item.category2
          ? this.category2Options.find(opt => opt.value === item.category2)?.label : ''

        // 从港口选项中获取港口名称
        const portOption = this.portOptions.find(option => option.value === item.port)
        const portName = portOption ? portOption.label.split(' - ')[1] : ''

        return {
          uuid: item.uuid,
          companyUuid: item.companyUuid,
          fleetCodeOne: fleetCodeOne,
          fleetTypeOne: fleetTypeOne,
          fleetNameOne: fleetNameOne,
          fleetCodeTwo: fleetCodeTwo,
          fleetTypeTwo: fleetTypeTwo,
          fleetNameTwo: fleetNameTwo,
          portCode: item.port,
          portName: portName
        }
      })

      return {
        branchFleetInfoList: branchFleetInfoList,
        deleteBranchFleetInfoKeys: this.deleteTruckClassificationKeys
      }
    },
    showEditDialog(isNew) {
      // 确保分类选项已经加载完成
      if (this.category1Options.length === 0 || this.category2Options.length === 0) {
        const loading = getLoading()
        this.loadCategoryOptions(() => {
          loading.close()
          this.openEditDialog(isNew)
        })
      } else {
        this.openEditDialog(isNew)
      }
    },
    openEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          category1: '',
          category2: '',
          port: '',
          companyUuid: this.company.uuid,
          seq: this.autoIncrementNum.getNextNum()
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        if (!this.selectedRow) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...this.selectedRow }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    save() {
      const form = this.editDialog.form
      // 校验分类1和分类2至少输入1个
      if (!form.category1 && !form.category2) {
        this.$message.warning('分类1，分类2 至少输入1个值')
        return
      }
      // 数据暂存
      const row = this.rowData.find(item => item.seq === form.seq)
      if (row) {
        Object.assign(row, form)
      } else {
        this.rowData.push(form)
      }
      // 刷新网格，确保显示正确的车队名称和港口名称
      if (this.gridApi) {
        this.gridApi.refreshCells({ force: true })
      }
      this.editDialog.visible = false
    },
    remove() {
      const row = this.selectedRow
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const index = this.rowData.findIndex(p => p.seq === row.seq)
        if (index >= 0) {
          this.rowData.splice(index, 1)
          if (row.uuid) {
            this.deleteTruckClassificationKeys.push(row.uuid)
          }
        }
      }).catch(() => { })
    }
  }
}
</script>

<style>
</style>
